import Ch1Leadership from '@/chapters/Ch1Leadership';
import Ch2NewEra from '@/chapters/Ch2NewEra';

export default function AboutPage() {
  return (
    <>
      {/* Talk about the company first, then the leadership messages (King + Crown Prince) */}
      <Ch2NewEra />
      <Ch1Leadership quotes={['quote1', 'quote2']} />
    </>
  );
}
